import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Scrollable } from '@sorare/core/src/atoms/navigation/Scrollable';

import { MobilePlayerPageFooterItem } from './Item/index.tsx';
import type { MobilePlayerPageFooter_anyPlayer } from './__generated__/index.graphql.ts';

type Props = { anyPlayer: MobilePlayerPageFooter_anyPlayer };

const Root = styled.div`
  padding: var(--double-unit);
`;

const rarities = [
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
] as const;

export const MobilePlayerPageFooter = ({ anyPlayer }: Props) => {
  const {
    lowestPriceLimitedCard,
    lowestPriceRareCard,
    lowestPriceSuperRareCard,
    lowestPriceUniqueCard,
  } = anyPlayer;

  const cardsByRarity = {
    [Rarity.limited]: lowestPriceLimitedCard,
    [Rarity.rare]: lowestPriceRareCard,
    [Rarity.super_rare]: lowestPriceSuperRareCard,
    [Rarity.unique]: lowestPriceUniqueCard,
  };

  return (
    <Root>
      <Scrollable itemToDisplay={1}>
        {rarities.map(r => (
          <MobilePlayerPageFooterItem
            key={r}
            rarity={r}
            anyCard={cardsByRarity[r]}
            playerSlug={anyPlayer.slug}
          />
        ))}
      </Scrollable>
    </Root>
  );
};

MobilePlayerPageFooter.fragments = {
  anyPlayer: gql`
    fragment MobilePlayerPageFooter_anyPlayer on AnyPlayerInterface {
      slug
      lowestPriceLimitedCard: lowestPriceAnyCard(
        inSeason: true
        rarity: limited
      ) {
        slug
        ...MobilePlayerPageFooterItem_anyCard
      }
      lowestPriceRareCard: lowestPriceAnyCard(rarity: rare) {
        slug
        ...MobilePlayerPageFooterItem_anyCard
      }
      lowestPriceSuperRareCard: lowestPriceAnyCard(
        inSeason: true
        rarity: super_rare
      ) {
        slug
        ...MobilePlayerPageFooterItem_anyCard
      }
      lowestPriceUniqueCard: lowestPriceAnyCard(
        inSeason: true
        rarity: unique
      ) {
        slug
        ...MobilePlayerPageFooterItem_anyCard
      }
    }
    ${MobilePlayerPageFooterItem.fragments.anyCard}
  ` as TypedDocumentNode<MobilePlayerPageFooter_anyPlayer>,
};
